import FormRegisterConfirm from '@/components/FormRegisterConfirm'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: FormRegisterConfirm,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}
